import React, {useEffect, useRef, useState} from 'react';
import './css/style.css';
import Footer from "../../footer/footer";
import {Helmet} from "react-helmet";
import TopBarTitle from "../../components/topBarTitle/topBarTitle";

import arrow_up from './img/arrow_up.png';
import LED_menu_button from './img/LED_menu_button.png'
import B2B_menu_button from './img/B2B_menu_button.png'
import IT_menu_button from './img/IT_menu_button.png'
import consult_menu_button from './img/consult_menu_button.png'

import cube_led from './img/cube_led.png'
import cube_b2b from './img/cube_b2b.png'
import cube_it from './img/cube_it.png'
import cube_konsaru from './img/cube_konsaru.png'

import LED_image1 from './img/LED_image1.jpg'
import LED_image2 from './img/LED_image2.jpg'
import LED_image3 from './img/LED_image3.jpg'
import LED_image4 from './img/LED_image4.png'
import LED_image5 from './img/LED_image5.jpg'

import B2B_image1 from './img/B2B_logo.jpg'
import B2B_image2 from './img/B2B_item.png'
import B2B_image3 from './img/B2B_tori.jpg'

import IT_image1 from './img/IT_image1.png'
import IT_image2 from './img/IT_image2.jpg'

import Konsaru_image1 from './img/Konsaru_image1.jpg'

// @ts-ignore
import movie from './img/LED_movie.mp4'
// @ts-ignore
import PDF from './document.pdf'


import ScrollToTop from "../../components/scrollToTopOnMount";
import {Link} from "react-router-dom";

import {scroller} from 'react-scroll';
import {useRecoilState} from "recoil";
import {contactContentSelectedInBusiness} from "../../globalState/contactContentSelectedInBusiness";



function Business() {
    const LED_button = useRef<null | HTMLImageElement>(null);
    const LED_wide = useRef<null | HTMLDivElement>(null);
    const LED_contents = useRef<null | HTMLDivElement>(null);

    const B2B_button = useRef<null | HTMLImageElement>(null);
    const B2B_wide = useRef<null | HTMLDivElement>(null);
    const B2B_contents = useRef<null | HTMLDivElement>(null);

    const IT_button = useRef<null | HTMLImageElement>(null);
    const IT_wide = useRef<null | HTMLDivElement>(null);
    const IT_contents = useRef<null | HTMLDivElement>(null);

    const konsaru_button = useRef<null | HTMLImageElement>(null);
    const konsaru_wide = useRef<null | HTMLDivElement>(null);
    const konsaru_contents = useRef<null | HTMLDivElement>(null);

    const arrow = useRef<null | HTMLDivElement>(null);

    const returnTop = ()=>{
        scroller.scrollTo("root", {
            smooth: true,
            offset: 0,
            duration: 500,
        });
    }

    let LED_scroll_open_allow = true;
    let B2B_scroll_open_allow = false;
    let IT_scroll_open_allow = false;
    let konsaru_scroll_open_allow = false;

    function set_LED_scroll_open_allow(status:boolean){
        LED_scroll_open_allow = status;
    }
    function set_B2B_scroll_open_allow(status:boolean){
        B2B_scroll_open_allow = status;
    }
    function set_IT_scroll_open_allow(status:boolean){
        IT_scroll_open_allow = status;
    }
    function set_konsaru_scroll_open_allow(status:boolean){
        konsaru_scroll_open_allow = status;
    }

    function allTrue(): void {
        LED_scroll_open_allow = true;
        B2B_scroll_open_allow = true;
        IT_scroll_open_allow = true;
        konsaru_scroll_open_allow = true;
    }

    function allClose(): void {
        LED_contents.current?.classList.add("close");
        B2B_contents.current?.classList.add("close");
        IT_contents.current?.classList.add("close");
        konsaru_contents.current?.classList.add("close");
    }

    function scroll(to:string,duration:Number):void{
        scroller.scrollTo(to, {
            smooth: true,
            offset: -200,
            duration: duration,
        });
    }

    function LED_button_click(): void {
        LEDSetOnce();
        allTrue();

        let delayFlag = false;
        allClose();


        B2B_scroll_open_allow = false;

        IT_scroll_open_allow = false;
        konsaru_scroll_open_allow = false;

        if (delayFlag) {
            setTimeout(function () {
                scroll(LED_contents.current?.id ?? "",1000);
                LED_contents.current?.classList.remove("close");
            }, 500);
        } else {
            scroll(LED_contents.current?.id ?? "",500);
        }
    }

    function B2B_button_click(): void {
        B2BSetOnce();
        allTrue();

        let delayFlag = false;
        if (!LED_contents.current?.classList.contains('close')) {
            delayFlag = true;
        }
        allClose();

        IT_scroll_open_allow = false;

        LED_scroll_open_allow = false;
        konsaru_scroll_open_allow = false;


        if (delayFlag) {
            setTimeout(function () {
                scroll(B2B_contents.current?.id ?? "",1000);
                B2B_contents.current?.classList.remove("close");
            }, 1000);
        } else {
            scroll(B2B_contents.current?.id ?? "",500);
        }
    }

    function IT_button_click(): void {
        ITSetOnce();
        allTrue();
        let delayFlag = false;
        if (!LED_contents.current?.classList.contains('close') ||
            !B2B_contents.current?.classList.contains('close')) {
            delayFlag = true;
        }
        allClose();
        LED_scroll_open_allow = false;
        B2B_scroll_open_allow = false;

        konsaru_scroll_open_allow = false;



        if (delayFlag) {
            setTimeout(function () {
                scroll(IT_contents.current?.id ?? "",1000);
                IT_contents.current?.classList.remove("close");
            }, 1000);
        } else {
            scroll(IT_contents.current?.id ?? "",500);
        }

    }

    function konsaru_button_click(): void {
        ConsultSetOnce();
        allTrue();

        let delayFlag = false;
        if (!LED_contents.current?.classList.contains('close') ||
            !B2B_contents.current?.classList.contains('close') ||
            !IT_contents.current?.classList.contains('close')) {
            delayFlag = true;
        }
        allClose();
        LED_scroll_open_allow = false;
        B2B_scroll_open_allow = false;
        IT_scroll_open_allow = false;


        if (delayFlag) {
            setTimeout(function () {
                scroll(konsaru_contents.current?.id ?? "",1000);
                konsaru_contents.current?.classList.remove("close");
            }, 1000);
        } else {
            scroll(konsaru_contents.current?.id ?? "",500);
        }
    }

    function LED_wide_click(): void {
        LEDSetOnce();
        LED_contents.current?.classList.toggle("close")
    }

    function B2B_wide_click(): void {
        B2BSetOnce();
        B2B_contents.current?.classList.toggle("close");
    }

    function IT_wide_click(): void {
        ITSetOnce();
        IT_contents.current?.classList.toggle("close")
    }

    function konsaru_wide_click(): void {
        ConsultSetOnce();
        konsaru_contents.current?.classList.toggle("close")
    }

    function isDownScroll(oldScroll: number, newScroll: number): boolean {
        return oldScroll < newScroll;
    }


    let LED_once_view = false;
    let B2B_once_view = false;
    let IT_once_view = false;
    let consult_once_view = false;


    function LEDSetOnce(): void {
        if (!LED_once_view) {
            // @ts-ignore
            window.gtag('event', 'business_detail', {'event_category': 'business', 'event_label': 'LED', 'value': '0'});
            LED_once_view = true;
        }
    }

    function B2BSetOnce(): void {
        if (!B2B_once_view) {
            // @ts-ignore
            window.gtag('event', 'business_detail', {'event_category': 'business', 'event_label': 'B2B', 'value': '0'});
            B2B_once_view = true;
        }
    }

    function ITSetOnce(): void {
        if (!IT_once_view) {
            // @ts-ignore
            window.gtag('event', 'business_detail', {'event_category': 'business', 'event_label': 'IT', 'value': '0'});
            IT_once_view = true;
        }
    }

    function ConsultSetOnce(): void {
        if (!consult_once_view) {
            // @ts-ignore
            window.gtag('event', 'business_detail', {
                'event_category': 'business',
                'event_label': 'Consult',
                'value': '0'
            });
            consult_once_view = true;
        }
    }

    const [isDownload, setIsDownload] = useState(false);

    function delaySetIsDownload(): void {
        if (!isDownload) {
            analyticsBusiness('pdf-LED')
            window.setTimeout(() => {
                setIsDownload(true);
            }, 100)
        }

    }

    useEffect(() => {


        let scrollAmount = 0;
        window.addEventListener("scroll", function () {
            let newScrollAmount = window.scrollY;

            const LED_position = LED_contents.current?.getBoundingClientRect().top ?? new DOMRect();
            const B2B_position = B2B_contents.current?.getBoundingClientRect().top ?? new DOMRect();
            const IT_position = IT_contents.current?.getBoundingClientRect().top ?? new DOMRect();
            const konsaru_position = konsaru_contents.current?.getBoundingClientRect().top ?? new DOMRect();

            if (isDownScroll(scrollAmount, newScrollAmount)) {
                if (LED_position <= window.innerHeight && LED_scroll_open_allow) {
                    set_LED_scroll_open_allow(false);
                    LED_contents.current?.classList.remove("close");
                    LEDSetOnce();
                    setTimeout(function () {
                        set_B2B_scroll_open_allow(true);
                    }, 500);
                }
                if (B2B_position <= window.innerHeight && B2B_scroll_open_allow) {
                    set_B2B_scroll_open_allow(false);
                    B2B_contents.current?.classList.remove("close");
                    B2BSetOnce();
                    setTimeout(function () {
                        set_IT_scroll_open_allow(true);
                    }, 500);
                }
                if (IT_position <= window.innerHeight && IT_scroll_open_allow) {
                    set_IT_scroll_open_allow(false);
                    IT_contents.current?.classList.remove("close");
                    ITSetOnce();
                    setTimeout(function () {
                        set_konsaru_scroll_open_allow(true);
                    }, 500);
                }
                if (konsaru_position <= window.innerHeight && konsaru_scroll_open_allow) {
                    set_konsaru_scroll_open_allow(false);
                    konsaru_contents.current?.classList.remove("close");
                    ConsultSetOnce();
                }
            }
            scrollAmount = newScrollAmount;


            //フッターが画面に入ったらtrue。そのタイミングで矢印を更新。
            const footer = document.getElementById("footer")!;
            if(arrow.current){
                if(footer.offsetTop - (window.scrollY + window.innerHeight) <= 0){
                    arrow.current?.classList.add("absolute_arrow");
                } else {
                    arrow.current?.classList.remove("absolute_arrow");
                }
            }
            if (LED_position <= window.innerHeight) {
                arrow.current?.classList.add("show_arrow");
            } else {
                arrow.current?.classList.remove("show_arrow");
            }
        })
        return () => {
            window.removeEventListener("scroll", function (){});
        }
    }, );

    function analyticsBusiness(link: string) {
        // @ts-ignore
        window.gtag('event', 'Click', {'event_category': 'business', 'event_label': link, 'value': '0'});
    }

    const [,setSelectBusiness] = useRecoilState(contactContentSelectedInBusiness)

    return (
        <>

            <ScrollToTop/>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>事業内容｜FDS</title>
                <meta name="Description"
                      content="FDSホールディングスは、LED看板広告、損害保険、不動産、アプリ開発/販売、企業ホームページ制作、システム受託開発、総合コンサルティング等といった様々な事業を展開しております。"/>
            </Helmet>
            <TopBarTitle title="事業内容"></TopBarTitle>
                <div id='business' >
                    <div className='container'>
                        <div className='text1 center'>
                            <div className='left'>
                                ホールディングスグループで培った<br className='tab'/> ノウハウを活かし、<br></br>
                                お客様を全力でサポートします。
                            </div>
                        </div>
                        <div className='menu-container container'>
                            <img src={LED_menu_button} className='col-3 led' id="LED_button" ref={LED_button} alt='' onClick={() => {
                                LED_button_click();
                                analyticsBusiness('menu-LED');
                            }}/>
                            <img src={B2B_menu_button} className='col-3 b2b' id="B2B_button" ref={B2B_button} alt='' onClick={() => {
                                B2B_button_click();
                                analyticsBusiness('menu-B2B');
                            }}/>
                            <img src={IT_menu_button} className='col-3 it' id="IT_button" ref={IT_button} alt='' onClick={() => {
                                IT_button_click();
                                analyticsBusiness('menu-IT');
                            }}/>
                            <img src={consult_menu_button} className='col-3 konsaru' id="konsaru_button" alt='' ref={konsaru_button}
                                 onClick={() => {
                                     konsaru_button_click();
                                     analyticsBusiness('menu-consult');
                                 }}/>
                        </div>

                        <div className="contents">
                            <div id="LED_wide" className="wide" ref={LED_wide} onClick={LED_wide_click}>
                                <div className='container'>
                                    <div className='text'>
                                        LED看板広告事業
                                    </div>
                                    <img src={cube_led} alt=''/>
                                </div>
                            </div>
                            <div id="LED_contents" className="body close" ref={LED_contents}>
                                <div id="LED_body">
                                    <div className='text1'>
                                        <div className='center'>
                                            <div className='left'>
                                                差し替え可能な屋外看板。<br/>
                                                LEDデジタル広告だから、動かせる、<br className='tab'/>変えられる、札幌駅に繋がる<br className='tab'/>幹線道路の広告で事業を動かそう!!
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text2'>
                                        ・自社ビル設置のLED看板広告サービス
                                    </div>
                                    <div className='text3'>
                                        動画の作成もFDSホールディングスに<br className='tab'/>
                                        お任せ下さい。
                                    </div>
                                    <div className='buttons'>
                                        <Link to='/contact' onClick={() => {analyticsBusiness('form-LED');setSelectBusiness("LED看板広告について")}}>
                                            <div className='formButton'>
                                                お問い合わせフォーム<span></span>{'>'}
                                            </div>
                                        </Link>

                                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                        <a href={isDownload ? null : PDF} download='FDS_LED事業紹介資料.pdf'
                                           onClick={() => delaySetIsDownload()} className={isDownload ? 'disable' : ''}>
                                            <div className='formButton'>
                                                資料ダウンロード<span className='documentSpan'></span>{'>'}
                                            </div>
                                        </a>
                                    </div>
                                    <div className='movie' onClick={() => analyticsBusiness('video-LED')}>
                                        <video src={movie} controls={true}/>
                                        <div className='text'>
                                            LED看板広告例
                                        </div>
                                    </div>
                                    <div className='images'>
                                        <img src={LED_image1} alt=''/>
                                        <img src={LED_image2} alt=''/>
                                        <img src={LED_image3} alt=''/>
                                        <img src={LED_image4} alt=''/>
                                        <div className='img5'>
                                            <div className='text1'>
                                                ※１サイクル300秒＝広告枠1枠15秒×最大20枠
                                            </div>
                                            <img src={LED_image5} alt=''/>
                                            <div className='text2'>
                                                【番組一覧表】
                                            </div>
                                            <div className='text3'>
                                                ※放映順序は一例です
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contents">
                            <div id="B2B_wide" className="wide" ref={B2B_wide} onClick={B2B_wide_click}>
                                <div className='container'>
                                    <div className='text'>
                                        B2B事業
                                    </div>
                                    <img src={cube_b2b} alt=''/>
                                </div>
                            </div>
                            <div id="B2B_contents" className="body close" ref={B2B_contents}>
                                <div id="B2B_body">
                                    <div className='text1'>
                                        <div className='left'>
                                            変化の激しい社会に備えと挑戦を。<br/>
                                            損害保険から代理店営業まで<br className='tab'/>FDSホールディングスに相談し<br className='pc'/>
                                            て<br className='tab'/>みませんか？
                                        </div>
                                    </div>
                                    <div className='form'>
                                        <Link to='/contact' onClick={() => {analyticsBusiness('form-B2B');setSelectBusiness("損害保険について");}}>
                                            <div className='formButton'>
                                                お問い合わせフォーム<span></span>{'>'}
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='text2'>
                                        ・損害保険
                                    </div>

                                    <div className='logo'>
                                        <img src={B2B_image1} alt=''/>
                                    </div>
                                    <div className='items'>
                                        <img src={B2B_image2} alt=''/>
                                    </div>
                                    <div className='tori'>
                                        <img src={B2B_image3} alt=''/>
                                    </div>
                                    <div className='text3 center'>
                                        <div className='left'>
                                            大切な家族の為に、守るべき会社の為に安心を備えませんか？<br/>
                                            お気軽に相談ください。
                                        </div>
                                    </div>
                                    <div className='text4'>
                                        <p>・不動産</p>
                                        <p>・代理店営業（予定）</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contents">
                            <div id="IT_wide" className="wide" ref={IT_wide} onClick={IT_wide_click}>
                                <div className='container'>
                                    <div className='text'>
                                        ITシステムAPP開発事業
                                    </div>
                                    <img src={cube_it} alt=''/>
                                </div>
                            </div>
                            <div id="IT_contents" className="body close" ref={IT_contents}>
                                <div id="IT_body">
                                    <div className='text1'>
                                        <div className='left'>
                                            ホームページからオリジナルアプリ開発<br className='tab'/> まで。<br/>
                                            お店や会社をデジタルでサポートします。<br/>
                                            お気軽にご相談下さい。
                                        </div>
                                    </div>
                                    <div className='form'>
                                        <Link to='/contact' onClick={() => {analyticsBusiness('form-IT');setSelectBusiness("ITシステムAPP開発について")}}>
                                            <div className='formButton'>
                                                お問い合わせフォーム<span></span>{'>'}
                                            </div>
                                        </Link>
                                    </div>
                                    <div className='text2'>
                                        小売業用会員サービスアプリ開発<br/>
                                        ・予約システム<br/>
                                        ・決済システム<br/>
                                        ・社内アプリシステム<br/>
                                        ・来店ポイントシステム<br/>
                                        ・クーポンシステム
                                    </div>
                                    <div className='image1'>
                                        <img src={IT_image1} alt=''/>
                                    </div>
                                    <div className='text3'>
                                        ・HP製作、デザイン<br/>
                                        ・企業カタログ製作<br/>
                                        ・広告デザイン<br/>
                                        ・キャラクター製作
                                    </div>
                                    <div className='image2'>
                                        <div className='text'>HP制作例</div>
                                        <img src={IT_image2} alt=''/>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="contents">
                            <div id="konsaru_wide" className="wide" ref={konsaru_wide} onClick={konsaru_wide_click}>
                                <div className='container'>
                                    <div className='text'>
                                        総合コンサルティング事業
                                    </div>
                                    <img src={cube_konsaru} alt=''/>
                                </div>
                            </div>
                            <div id="konsaru_contents" className="body close" ref={konsaru_contents}>
                                <div id="konsaru_body">
                                    <div className='text1 center'>
                                        <div className='left'>
                                            中小企業やサービス業の人材開発から<br className='tab'/> 働き方改革等、労務<br className='pc'/>
                                            の課題解決やDX、<br className='tab'/>ビジネス用システムやAPP等幅広く<br className='tab'/>様々<br
                                            className='pc'/>
                                            な課題を解決することができます。
                                        </div>
                                    </div>
                                    <div className='text2'>
                                        ・経営コンサルティング<br/>
                                        ・人材育成コンサルティング<br/>
                                        ・人材採用コンサルティング<br/>
                                        ・IT・DXコンサルティング
                                    </div>
                                    <div className='image1'>
                                        <img src={Konsaru_image1} alt=''/>
                                    </div>
                                    <div className='form'>
                                        <Link to='/contact' onClick={() => {analyticsBusiness('form-consult');setSelectBusiness("コンサルティングについて");}}>
                                            <div className='formButton'>
                                                お問い合わせフォーム<span></span>{'>'}
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="top_arrow" ref={arrow}>
                        <div onClick={returnTop}>
                            <img src={arrow_up} alt="矢印ボタン"/>
                        </div>
                    </div>
                </div>
            <Footer></Footer>
        </>

    );
}


export default Business;
